const {createAction} = require('@src/components/redux-act');

export const getUserInfoSagaAction = createAction('获取用户信息');
export const getUserInfoAction = createAction('更新用户信息');
export const getTenantInfoSagaAction = createAction('获取服务商信息');
export const getSiteTypeSagaAction = createAction('获取站点类型信息');
export const getTenantCheckisv = createAction('获取服务商是否是isv身份');
export const getTenantInfoAction = createAction('更新服务商信息');
export const getSiteTypeAction = createAction('更新站点类型信息');

export const getGlobalDataSagaAction = createAction('getGlobalDataSaga');
export const getNavMenuAction = createAction('getNavMenu');

export const getLicenseAction = createAction('getLicenseSaga');
export const getReady = createAction('ready');
export const getUserReady = createAction('userReady');
export const getSiteReady = createAction('siteReady');
export const getSearchKey = createAction('getSearchKey')

export const isv = createAction('isv')

export const successOpen = createAction('开通成功')

export const okFlag = createAction('基本信息确定按钮')
export const cancleFlag = createAction('基本信息取消按钮')
export const routeFlag = createAction('编辑页面点击路由')
export const changeRouter = createAction('点击获取到的路由')
export const searchFlag = createAction('是否点击搜索按钮')

/**
 * 微评估相关acitons
 */
// 企业信息
export const setAppData = createAction('设置企业信息')

//  消息通知中心
export const confirmNewsIndex = createAction('通知中心的点击数据')
export const confirmNewsNumber = createAction('通知中心的点击数据')


// 白名单
export const setWhiteList = createAction('设置白名单');
// 应用信息
export const setAppInfo = createAction('应用基本信息');
// 用户角色
export const setRoleType = createAction('用户角色');
// 应用基本信息
export const appBaseInfo = createAction('应用基本信息');
// 应用能力菜单
export const abilityMenuList = createAction('应用能力菜单');
